<template>
  <div class="p-3">
    <div class="card shadow-sm border border-gray rounded mb-3">
      <div class="card-header bg-white border-bottom py-2">
        <h6 class="mb-0 font-weight-bold text-dark">
          <i class="fas fa-search mr-2"></i>Buscar tramos
        </h6>
      </div>
      <div class="card-body py-3">
        <div class="row align-items-end">
          <div class="col-12 col-md-6 mb-2 mb-md-0">
            <label class="small text-muted mb-1">Nombre o referencia</label>
            <input
              type="text"
              class="form-control form-control-sm"
              v-model="busqueda"
              @keyup.enter="buscarTramos()"
              placeholder="Buscar tramos de rutas..."
            />
          </div>
          <div class="col-6 col-md-3 mb-2 mb-md-0">
            <label class="small text-muted mb-1">Kilómetros a la redonda</label>
            <input
              type="number"
              class="form-control form-control-sm"
              v-model.number="distanciaMaximaKm"
              @blur="validarDistanciaMaxima"
              @change="validarYFiltrar"
              min="1"
              max="50"
              step="1"
            />
          </div>
          <div class="col-6 col-md-3">
            <button
              type="button"
              class="btn btn-primary btn-sm w-100"
              @click="buscarTramos()"
            >
              <i class="fas fa-search mr-1"></i> Buscar
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- Lista de tramos añadidos -->
    <div
      class="card shadow-sm border-0 rounded mb-3"
      v-if="tramosAñadidos.length > 0"
    >
      <div class="card-header bg-primary text-white py-2">
        <h6 class="mb-0 d-flex align-items-center font-weight-bold">
          <i class="fas fa-route mr-2"></i>
          Tramos añadidos
          <span class="badge badge-light badge-pill ml-2 text-primary">{{
            tramosAñadidos.length
          }}</span>
        </h6>
      </div>
      <div class="card-body p-0">
        <div class="list-group list-group-flush">
          <div
            v-for="(tramo, index) in tramosAñadidos"
            :key="tramo.id"
            class="list-group-item list-group-item-action d-flex justify-content-between align-items-center py-2"
            :class="{
              'list-group-item-light': index === tramosAñadidos.length - 1,
            }"
          >
            <div class="flex-grow-1">
              <span class="badge badge-primary badge-pill mr-2">{{
                index + 1
              }}</span>
              <span>{{ tramo.nombre }}</span>
            </div>
            <button
              type="button"
              class="btn btn-sm btn-outline-danger ml-2"
              @click.stop="eliminarTramo(index)"
              title="Quitar tramo"
            >
              <i class="fas fa-times"></i>
            </button>
          </div>
        </div>
      </div>
    </div>

    <div class="card shadow-sm border border-gray rounded">
      <div class="card-header bg-white border-bottom py-2">
        <h6 class="mb-0 font-weight-bold text-dark">
          <i class="fas fa-list mr-2"></i>Tramos disponibles
          <span class="badge badge-secondary badge-pill ml-2" v-if="tramosFiltrados.length > 0">
            {{ tramosFiltrados.length }} (dentro de {{ distanciaMaximaKm }} km)
          </span>
        </h6>
      </div>
      <div class="card-body p-0">
        <loading v-if="cargando" />
        <div v-else>
          <div v-if="tramosFiltrados.length === 0" class="p-4 text-center">
            <span class="badge badge-warning badge-pill py-2 px-3">
              No hay tramos dentro de {{ distanciaMaximaKm }} km
            </span>
            <p class="small text-muted mt-2 mb-0">
              Ajusta "Kilómetros a la redonda" o busca por nombre.
            </p>
          </div>
          <div v-else class="list-group list-group-flush">
            <div
              v-for="tramo in tramosFiltrados"
              :key="tramo.id"
              class="list-group-item d-flex justify-content-between align-items-center py-2"
            >
              <div class="flex-grow-1">
                <span class="text-dark">{{ tramo.nombre }}</span>
                <span class="badge badge-info badge-pill ml-2" v-if="tramo.distanciaAlOrigen != null">
                  {{ (tramo.distanciaAlOrigen / 1000).toFixed(1) }} km
                </span>
              </div>
              <button
                type="button"
                class="btn btn-success btn-sm"
                @click="añadirTramo(tramo)"
                :disabled="yaEstaAñadido(tramo)"
              >
                <i class="fas fa-plus mr-1"></i> Añadir
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import loading from "@/components/Loading.vue";
import axios from "axios";
const google = window.google;

export default {
  name: "TepRutaTramo",
  components: { loading },
  props: {
    accionRuta: { type: Boolean, default: false },
    tramosIniciales: { type: Array, default: () => [] },
  },
  data() {
    return {
      cargando: false,
      busqueda: "",
      tramos: [],
      tramosFiltrados: [],
      tramosAñadidos: [],
      puntoReferencia: null,
      distanciaMaximaKm: 50,
    };
  },
  methods: {
    obtenerCoordenadasRuta(ruta, tipo) {
      if (!ruta) return null;
      let lat = null, lng = null;
      if (tipo === "origen") {
        if (ruta.lat_origen != null && ruta.lng_origen != null) {
          lat = parseFloat(ruta.lat_origen);
          lng = parseFloat(ruta.lng_origen);
        } else if (ruta.ruta_polilineas && ruta.ruta_polilineas.length > 0) {
          const p = ruta.ruta_polilineas.find((x) => x.orden === 1) || ruta.ruta_polilineas[0];
          lat = parseFloat(p.lat_ini);
          lng = parseFloat(p.lon_ini);
        }
      } else if (tipo === "destino") {
        if (ruta.lat_destino != null && ruta.lng_destino != null) {
          lat = parseFloat(ruta.lat_destino);
          lng = parseFloat(ruta.lng_destino);
        } else if (ruta.ruta_polilineas && ruta.ruta_polilineas.length > 0) {
          const p = ruta.ruta_polilineas[ruta.ruta_polilineas.length - 1];
          lat = parseFloat(p.lat_fin);
          lng = parseFloat(p.lon_fin);
        }
      }
      return lat != null && lng != null ? { lat, lng } : null;
    },
    validarDistanciaMaxima() {
      if (this.distanciaMaximaKm === null || this.distanciaMaximaKm === undefined || this.distanciaMaximaKm === "") {
        this.distanciaMaximaKm = 50;
        return;
      }
      const valor = parseFloat(this.distanciaMaximaKm);
      if (isNaN(valor)) {
        this.distanciaMaximaKm = 50;
        return;
      }
      if (valor > 50) {
        this.distanciaMaximaKm = 50;
        this.$swal({
          icon: "warning",
          title: "Distancia máxima permitida",
          text: "La distancia máxima no puede ser mayor a 50 km",
          toast: true,
          position: "top-end",
          showConfirmButton: false,
          timer: 3000,
          timerProgressBar: true,
        });
      } else if (valor < 1) {
        this.distanciaMaximaKm = 1;
      }
    },
    validarYFiltrar() {
      this.validarDistanciaMaxima();
      this.filtrarTramosCercanos();
    },
    obtenerPuntoReferencia() {
      const rutaDetalle = this.$parent;
      if (rutaDetalle && rutaDetalle.ruta) {
        const origen = this.obtenerCoordenadasRuta(rutaDetalle.ruta, "origen");
        if (origen) this.puntoReferencia = origen;
      }
    },
    calcularDistancia(origen, destino) {
      if (!origen || !destino || destino.lat == null || destino.lng == null) return Infinity;
      if (typeof google === "undefined" || !google.maps || !google.maps.geometry || !google.maps.geometry.spherical) {
        const R = 6371000;
        const dLat = ((destino.lat - origen.lat) * Math.PI) / 180;
        const dLon = ((destino.lng - origen.lng) * Math.PI) / 180;
        const a =
          Math.sin(dLat / 2) * Math.sin(dLat / 2) +
          Math.cos((origen.lat * Math.PI) / 180) * Math.cos((destino.lat * Math.PI) / 180) * Math.sin(dLon / 2) * Math.sin(dLon / 2);
        const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
        return R * c;
      }
      return google.maps.geometry.spherical.computeDistanceBetween(
        new google.maps.LatLng(origen.lat, origen.lng),
        new google.maps.LatLng(destino.lat, destino.lng)
      );
    },
    yaEstaAñadido(tramo) {
      if (!tramo || !this.tramosAñadidos.length) return false;
      const id = tramo.id != null ? String(tramo.id) : null;
      return this.tramosAñadidos.some((ta) => ta.id != null && String(ta.id) === id);
    },
    añadirTramo(tramo) {
      if (this.yaEstaAñadido(tramo)) return;
      axios
        .get("/api/tep/tramosRutas/" + tramo.id)
        .then((response) => {
          const completo = response.data.data || response.data;
          this.tramosAñadidos.push({ ...tramo, ...completo });
          this.filtrarTramosCercanos();
        })
        .catch(() => {
          this.tramosAñadidos.push({ ...tramo });
          this.filtrarTramosCercanos();
        });
    },
    eliminarTramo(index) {
      this.tramosAñadidos.splice(index, 1);
      this.filtrarTramosCercanos();
    },
    filtrarTramosCercanos() {
      if (!this.puntoReferencia) this.obtenerPuntoReferencia();
      if (!this.puntoReferencia) {
        this.tramosFiltrados = this.tramos.filter((t) => !this.yaEstaAñadido(t));
        return;
      }
      const distanciaMaximaMetros = this.distanciaMaximaKm * 1000;
      this.tramosFiltrados = this.tramos
        .filter((t) => !this.yaEstaAñadido(t) && t.lat_origen != null && t.lng_origen != null && !isNaN(parseFloat(t.lat_origen)) && !isNaN(parseFloat(t.lng_origen)))
        .map((t) => ({
          ...t,
          distanciaAlOrigen: this.calcularDistancia(this.puntoReferencia, {
            lat: parseFloat(t.lat_origen),
            lng: parseFloat(t.lng_origen),
          }),
        }))
        .filter((t) => t.distanciaAlOrigen <= distanciaMaximaMetros)
        .sort((a, b) => a.distanciaAlOrigen - b.distanciaAlOrigen);
    },
    buscarTramos() {
      this.cargando = true;
      axios
        .get("/api/tep/tramosRutas", {
          params: {
            nombre: this.busqueda || undefined,
            per_page: 200,
          },
        })
        .then((response) => {
          this.tramos = response.data.data || response.data || [];
          if (Array.isArray(response.data)) this.tramos = response.data;
          this.obtenerPuntoReferencia();
          this.filtrarTramosCercanos();
          this.cargando = false;
        })
        .catch(() => {
          this.tramos = [];
          this.tramosFiltrados = [];
          this.cargando = false;
        });
    },
  },
  watch: {
    tramosIniciales: {
      handler(val) {
        if (Array.isArray(val) && val.length > 0) {
          this.tramosAñadidos = val.map((t) => JSON.parse(JSON.stringify(t)));
          this.filtrarTramosCercanos();
        }
      },
      deep: true,
      immediate: true,
    },
    accionRuta(val) {
      if (val && this.tramos.length === 0) this.buscarTramos();
      if (val) this.filtrarTramosCercanos();
    },
  },
  mounted() {
    if (this.accionRuta) this.buscarTramos();
  },
};
</script>
